module.exports = __webpack_public_path__ + "static/media/GT02_ST_Accommodation-Types.cf3f151f.csv";